import { useQuery } from '@tanstack/react-query'

import { getBookingServiceById } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

type QueryPayload = {
  bookingId?: ParameterID
  serviceId?: ParameterID
}

export function useQueryGetBookingServiceById({
  bookingId,
  serviceId,
}: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetBookingServiceById'],
    queryFn: async () =>
      await getBookingServiceById(bookingId ?? '', serviceId ?? ''),
    refetchOnWindowFocus: false,
  })
}
